{
    "locales": ["de-ch", "en", "it-ch", "fr-ch"],
    "prefix": "routes."
}
